import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Grid, GridItem, Heading } from '@tq/ui-components';
import { tqc } from '@tq/ui-components/dist/system';

import { ReviewResponse } from '../../types';
import { ReviewCard } from './ReviewCard';

export const Review: React.FC = () => {
  const { t } = useTranslation('dfi_report_review');

  return (
    <>
      <Heading size='lg'>{t('review', 'Review')}</Heading>
      <Typography>
        <tqc.p>
          {t(
            'review_sub_heading_text',
            'Consultees can use the report to highlight to the Department any initiatives or practices that may improve the consultation process. This may be a consultee committing to providing guidance or standing advice for use by planning officers that will negate the need for a consultation or it may propose an approach to dealing with consultations within its own organisation in a more efficient manner.'
          )}
        </tqc.p>
      </Typography>
      <Grid gridGap={5} mt={4}>
        <GridItem>
          <ReviewCard
            question={t(
              'dfi_review_question_1',
              'Please highlight below any initiatives or best practices you have developed which have improved your consultation process and could be shared with other consultees to make the consultation process more streamlined for all.'
            )}
            idReference={ReviewResponse.BestPracticeResponse}
          />
        </GridItem>
        <GridItem>
          <ReviewCard
            question={t(
              'dfi_review_question_2',
              'Please highlight any issues that you have had with the consultation process which you feel have hampered your ability to respond to consultation requests.'
            )}
            idReference={ReviewResponse.InfoOnLateResponse}
          />
        </GridItem>
      </Grid>
    </>
  );
};
